import React from "react";
// import PropTypes from "prop-types";

import SubPurposesSelect from "../../shared/containers/filters/sub_purposes";
import MinMaxSelect from "../../shared/containers/filters/min_max";
import RegionsSelect from "../../shared/containers/filters/regions";

class AdvancedFilters extends React.Component {
  render () {
    return (
      <div className="advanced-filters">
        <div className="row">
          <SubPurposesSelect />
          <MinMaxSelect />
          <RegionsSelect />
        </div>
      </div>
    );
  }
}

AdvancedFilters.propTypes = {
  // searchIsBeingSaved: PropTypes.bool.isRequired,
};

export default AdvancedFilters;
